import axios from 'axios';

// Default to same-origin URLs in every environment. Deployments can still
// override either value without rebuilding the API.
const baseURL = process.env.REACT_APP_API_URL || '/api/';
const origin = process.env.REACT_APP_ASSET_ORIGIN || '/';

const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});

const request = {
  origin,
  baseURL,
  axiosInstance,
  throttling: 0, // optional, in ms. Example: 500 for half-second throttling

  async get(url, config) {
    try {
      const res = await axiosInstance.get(url, config);
      if (this.throttling) {
        await new Promise(resolve => setTimeout(resolve, this.throttling));
      }
      return res;
    } catch (err) {
      if (this.throttling) {
        await new Promise(resolve => setTimeout(resolve, this.throttling));
      }
      this.handleError(err);
      throw err;
    }
  },

  async post(url, data, config) {
    try {
      const res = await axiosInstance.post(url, data, config);
      if (this.throttling) {
        await new Promise(resolve => setTimeout(resolve, this.throttling));
      }
      return res;
    } catch (err) {
      if (this.throttling) {
        await new Promise(resolve => setTimeout(resolve, this.throttling));
      }
      this.handleError(err);
      throw err;
    }
  },

  async delete(url, config) {
    try {
      const res = await axiosInstance.delete(url, config);
      if (this.throttling) {
        await new Promise(resolve => setTimeout(resolve, this.throttling));
      }
      return res;
    } catch (err) {
      if (this.throttling) {
        await new Promise(resolve => setTimeout(resolve, this.throttling));
      }
      this.handleError(err);
      throw err;
    }
  },

  handleError(err) {
    if (err.response?.status === 403) {
      console.warn('Unauthorized access (403)');
      // Add your redirect/logout logic if needed
    }
  }
};

export default request;
